import { useRef } from 'react';

const useSharedDataSnapshot = (getSharedData) => {
  const snapshotRef = useRef(null);

  if (!snapshotRef.current) {
    snapshotRef.current = getSharedData();
  }

  return snapshotRef.current;
};

export default useSharedDataSnapshot;
